import { observer } from "mobx-react";
import { useEffect, useState } from "react";
//import LoadingComponent from "../../../app/layout/LoadingComponent";
import { useStore } from "../../../app/stores/store";
import HeaderWrapper from "../../header/HeaderWrapper";
import GroupsGrid from "./GroupsGrid";
import Breadcrumb from "../../../app/common/common-components/Breadcrumb";

export default observer(function GroupsPage() {
  const {
    userStore: { userSession, logout, isLoggedIn },
  } = useStore();

  document.title = "Base - Groups";

  return (
    <>
      <div className="container-fluid">
        <Breadcrumb breadcrumbs={[{ text: "Home", path: "/" }, { text: "Settings", path: "/settings" }, { text: "Groups" }]} />

        <div className="row">
          <div id="content" className="col-sm-12 col-md-12">
            <GroupsGrid />
          </div>
        </div>
      </div>
    </>
  );
});
